import { defineMessages } from 'react-intl';

export const dialogConfirmationTranslations = defineMessages({
  confirmTitle: {
    id: 'dialog.confirmation.title',
    defaultMessage: 'Delete',
    description: 'Confirmation dialog title',
  },
  confirmDescription: {
    id: 'dialog.confirmation.description',
    defaultMessage: 'Are you sure you want to delete {item}?',
    description: 'Confirmation dialog description',
  },
  confirmButton: {
    id: 'dialog.confirmation.confirmButton',
    defaultMessage: 'Confirm',
    description: 'Confirmation dialog confirm button',
  },
  backButton: {
    id: 'dialog.confirmation.backButton',
    defaultMessage: 'Cancel',
    description: 'Confirmation dialog back button',
  },
});
